/**
 * 购物车档位提示（按金额）
 * 规则：
 *   现在 ~ 2026-12-01 00:00 美东（BFCM）  全场 20% / 满 $500 25% / 满 $1000 30%
 *   2026-12-01 之后（常规）                任意 10% / 满 $500 15% / 满 $1000 20%
 * 折扣按「可折扣商品」的小计计算，定制商品（no-discount）不参与。
 *
 * 依赖：<cart-tier-message data-no-discount-ids="100,200,300">
 * 数据来源：/cart.js
 */
class CartTierMessage extends HTMLElement {
  connectedCallback() {
    this.el = this.querySelector('[data-tier-message]');
    this.noteEl = this.querySelector('[data-tier-note]');
    this.ids = new Set(
      (this.dataset.noDiscountIds || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
    );

    document.addEventListener('cart:updated', () => this.load());
    document.addEventListener('cart-drawer:open', () => this.load());
    this.load();
  }

  isCampaign() {
    const t = Date.now();
    return t >= Date.parse('2026-11-13T05:00:00Z') && t < Date.parse('2026-12-01T05:00:00Z');
  }

  tiers() {
    return this.isCampaign()
      ? [{ min: 0, pct: 20 }, { min: 500, pct: 25 }, { min: 1000, pct: 30 }]
      : [{ min: 0, pct: 10 }, { min: 500, pct: 15 }, { min: 1000, pct: 20 }];
  }

  load() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => this.render(cart))
      .catch(() => {});
  }

  totals(cart) {
    let eligible = 0;
    let custom = 0;
    (cart.items || []).forEach((item) => {
      const isCustom =
        this.ids.has(item.product_id) || this.ids.has(String(item.product_id));
      const line = (item.final_line_price || 0) / 100;
      if (isCustom) {
        custom += line;
      } else {
        eligible += line;
      }
    });
    return { eligible, custom };
  }

  money(n) {
    return '$' + (Math.ceil(n * 100) / 100).toFixed(0);
  }

  render(cart) {
    if (!this.el) return;

    if (!cart.item_count) {
      this.style.display = 'none';
      return;
    }
    this.style.display = '';

    const { eligible, custom } = this.totals(cart);
    const t = this.tiers();

    if (eligible <= 0) {
      this.el.textContent = 'Custom pieces are excluded from all discounts.';
    } else {
      let idx = 0;
      for (let i = t.length - 1; i >= 0; i--) {
        if (eligible >= t[i].min) { idx = i; break; }
      }
      const cur = t[idx];
      const next = t[idx + 1];
      if (!next) {
        this.el.textContent = `🎉 ${cur.pct}% OFF applied — you've hit the best tier!`;
      } else {
        const gap = next.min - eligible;
        this.el.textContent =
          `✓ ${cur.pct}% OFF applied · Add ${this.money(gap)} more to save ${next.pct}%`;
      }
    }

    if (this.noteEl) {
      if (custom > 0) {
        this.noteEl.textContent =
          "Custom pieces don't count toward discount tiers.";
        this.noteEl.hidden = false;
      } else {
        this.noteEl.textContent = '';
        this.noteEl.hidden = true;
      }
    }
  }
}

if (!customElements.get('cart-tier-message')) {
  customElements.define('cart-tier-message', CartTierMessage);
}
